import { useQuery } from '@tanstack/react-query'
import { getData } from '../../apis/api.helpers'
import apiUrl from '../../apis/api.url'
import { parseQueryParams } from '../../utilities/parsers'
import { useAuthStore } from '../../store/authStore'
const buildUrlWithParams = (baseUrl: string) => {
  return `${baseUrl}${parseQueryParams()}`
}

const fetchBanner = async () => {
  const url = buildUrlWithParams(apiUrl.BANNER_LIST)
  const response = await getData(url)
  return response
}
const fetchBannerUser = async () => {
  const url = buildUrlWithParams(apiUrl.BANNER_LIST_USER)
  const response = await getData(url)
  return response
}

export const useBannerList = () => {
  const authenticated = useAuthStore((state) => state.authenticated)
  return useQuery(
    ['members_listing', authenticated],
    () => {
      if (authenticated) {
        return fetchBannerUser()
      } else {
        return fetchBanner()
      }
    },
    {
      refetchOnWindowFocus: false,
    }
  )
}
const fetchTestimonial = async () => {
  const url = buildUrlWithParams(apiUrl.TESTIMONIALS)
  const response = await getData(url)
  return response
}
const fetchTestimonialUser = async () => {
  const url = buildUrlWithParams(apiUrl.TESTIMONIALS)
  const response = await getData(url)
  return response
}

export const useTestimonialList = () => {
  const authenticated = useAuthStore((state) => state.authenticated)

  return useQuery(
    ['testimonials_listing', authenticated],
    () => {
      if (authenticated) {
        return fetchTestimonialUser()
      } else {
        return fetchTestimonial()
      }
    },
    {
      refetchOnWindowFocus: false,
    }
  )
}
const fetchAdvertisement = async () => {
  const url = buildUrlWithParams(apiUrl.ADVERTISEMENT_LIST)
  const response = await getData(url)
  return response
}

export const useFetchAdvertisement = () => {
  return useQuery(['worker_jobtype_listing'], () => fetchAdvertisement(), {
    refetchOnWindowFocus: false,
  })
}
const fetchYoutubeVideos = async () => {
  const url = buildUrlWithParams(apiUrl.VIDEOS)
  const response = await getData(url)
  return response
}

export const useYoutubeVideos = () => {
  return useQuery(['videos_listing'], () => fetchYoutubeVideos(), {
    refetchOnWindowFocus: false,
  })
}

const tranningCalender = async () => {
  const response = await getData(apiUrl.TRAININGCALENDAR)
  return response
}

export const useTranningCalender = () => {
  return useQuery(['tranning-calender'], tranningCalender)
}
const fetchPartners = async () => {
  const url = buildUrlWithParams(apiUrl.PARTNER_LIST)
  const response = await getData(url)
  return response
}

export const usePartners = () => {
  return useQuery(['partners_listing'], () => fetchPartners(), {
    refetchOnWindowFocus: false,
  })
}
const fetchPhotos = async () => {
  const url = buildUrlWithParams(apiUrl.PHOTO_LIST)
  const response = await getData(url)
  return response
}

export const usePhotos = () => {
  return useQuery(['photo_listing'], () => fetchPhotos(), {
    refetchOnWindowFocus: false,
  })
}
